<template>
    <v-autocomplete
        ref="searchRef"
        v-model="productId"
        :items="products"
        item-title="name"
        item-value="id"
        :loading="isLoading"
        hide-no-data
        :label="label"
        clearable
        :rules="rules"
        :disabled="disabled"
        :hide-details="hideDetails"
        :density="dense ? 'compact' : 'comfortable'"
        @update:search="onSearch"
        @focus="searchRef.reset()"
        @blur="updateForm"
    />
</template>

<script setup lang="ts">
    const props = defineProps<{
        method: string
        cityId?: number | null
        label?: string
        rules?: any[]
        disabled?: boolean
        hideDetails?: boolean
        dense?: string
    }>()

    const products = ref([])
    const isLoading = ref<boolean>(false)
    const search = ref<string>(null)
    const timer = ref(null)
    const searchRef = ref()

    const productId = defineModel<string>()

    const app = useNuxtApp()

    watch(
        () => props.cityId,
        async (): Promise<void> => {
            productId.value = null
            products.value = []
        }
    )

    onMounted(async () => {
        if (productId.value) await loadData({id: productId.value})
    })

    async function loadData(rq) {
        try {
            isLoading.value = true
            const {ownProductContracts} = await app.$api[props.method].get({
                ...rq,
                ...(props.cityId && {cityId: props.cityId}),
            })
            products.value = ownProductContracts
        } catch (e) {
            products.value = []
        } finally {
            isLoading.value = false
        }
    }

    const updateForm = () => {
        if (!products.value?.length) searchRef.value.reset()
    }

    const onSearch = val => {
        if (!val) return
        search.value = val

        if (search.value) {
            if (timer.value) {
                clearTimeout(timer.value)
            }

            timer.value = window.setTimeout(() => {
                loadData({
                    limitCities: -1,
                    orderBy: 'ALPHABET',
                    pattern: search.value,
                })
            }, 400)
        }
    }
</script>
